import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  header: {
    position: 'sticky',
    top: 0,
    display: 'flex',
    gap: '0.75rem',
    flexDirection: 'column',
    fontFamily: 'PP Object Sans',
    '@media screen and (width >= 520px)': {
      padding: '0 0 0 1rem',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  leftSide: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    color: neutral['60'],
  },
  title: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 500,
  },
  storeName: {
    fontSize: '0.875rem',
    lineHeight: '1rem',
    fontWeight: 500,
    color: neutral[100],
    '@media screen and (width >= 768px)': {
      fontSize: '1rem',
      lineHeight: '1.25rem',
    },
    '@media screen and (width >= 1024px)': {
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
    },
  },

  rightSide: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
  },
  searcher: {
    width: '21rem',
    borderRadius: '1rem',
    color: neutral[60],
    backgroundColor: neutral.white,
    '& .MuiInputBase-root': {
      borderRadius: 'inherit',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${neutral[20]}`,
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${neutral[40]}`,
      },
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: neutral[40],
        },
      },
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '1rem',
    },
    '& .MuiInputBase-input': {
      height: 'inherit',
      padding: '0.75rem',
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      fontFamily: 'PP Object Sans',
    },
  },
  searcherIcon: {
    color: neutral[60],
  },
  filterBtn: {
    minWidth: 'auto',
    padding: '0.75rem 0.5rem',
    whiteSpace: 'nowrap',
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1rem',
    color: neutral[100],
    borderRadius: '1rem',
    borderColor: neutral[90],
    backgroundColor: neutral.white,
    '&:hover': {
      borderColor: 'inherit',
    },
  },

  rotateCenter: {
    '-webkit-animation': '$rotate-center 0.8s linear infinite',
    animation: '$rotate-center 0.8s linear infinite',
  },
  '@-webkit-keyframes rotate-center': {
    from: {
      '-webkit-transform': 'rotate(0)',
      transform: 'rotate(0)',
    },
    to: {
      '-webkit-transform': 'rotate(360deg)',
      transform: 'rotate(360deg)',
    },
  },
  '@keyframes rotate-center': {
    from: {
      '-webkit-transform': 'rotate(0)',
      transform: 'rotate(0)',
    },
    to: {
      '-webkit-transform': 'rotate(360deg)',
      transform: 'rotate(360deg)',
    },
  },
});
